import type { FieldSpec } from '@moment/horizon-data-access/platform'
import type { ReferenceDataField } from '@moment/trading-types/instrument-data'

import { SECURITY_FIELD_BY_INSTRUMENT_FIELD } from './security-instrument-fields'
import { SECURITY_ENTITY } from './security-wire-fields'

/**
 * Live inventory's `duration`: the price-estimate duration, else the
 * reference-data one. Expressions name it bare; filters and sorts qualify it.
 */
export const DURATION_COLUMN = 'mpe_or_reference_duration'

const DURATION_SOURCES = ['mpe_duration', 'duration']

export const DURATION_COLUMN_SPEC: FieldSpec = {
  alias: DURATION_COLUMN,
  expr: `COALESCE(${DURATION_SOURCES.map((field) => `${SECURITY_ENTITY}.${field}`).join(', ')})`,
}

/** The Security field or computed column serving a live-inventory reference-data field. */
export function securityReadField(
  field: ReferenceDataField,
): string | undefined {
  return field === 'duration'
    ? DURATION_COLUMN
    : SECURITY_FIELD_BY_INSTRUMENT_FIELD.get(field)
}

/** How an expression reads a Security field or the duration column. */
export function securityExpressionRef(field: string): string {
  return field === DURATION_COLUMN ? field : `${SECURITY_ENTITY}.${field}`
}

/** Whether a schema serving `fields` can compute the duration column. */
export function canComputeDuration(fields: ReadonlySet<string>): boolean {
  return DURATION_SOURCES.every((field) => fields.has(field))
}

/** `fields` plus the duration column when `request` names it and `fields` does not declare it. */
export function declareDurationColumn(
  fields: FieldSpec[],
  request: unknown,
): FieldSpec[] {
  const declared = fields.some(
    (spec) => spec.alias === DURATION_COLUMN && spec.expr,
  )
  return declared || !JSON.stringify(request).includes(DURATION_COLUMN)
    ? fields
    : [...fields, DURATION_COLUMN_SPEC]
}
